<template>
  <div class="zongbao">
    <div class="left">
      <div class="title">配电室列表</div>
      <ul>
        <li
          v-for="(item, index) in leftList"
          :key="index"
          @click="roomClickHandle(index, item.id)"
        >
          <img :src="getImgSrc(index)" alt="" />
          <div class="sspan">
            {{ item.name }}
          </div>
          <span>{{ item.count }}</span>
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="title">项目结构图</div>
      <div class="box">
        <el-tree
          :data="data"
          node-key="id"
          :indent="0"
          :default-expanded-keys="[2, 3]"
          :default-checked-keys="[5]"
        >
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      leftList: [],
      leftIndex: 0,
      leftId: "",
      data: [
        {
          id: 1,
          label: "一级 2",
          children: [
            {
              id: 3,
              label: "二级 2-1",
              children: [
                {
                  id: 4,
                  label: "三级 3-1-1",
                },
                {
                  id: 5,
                  label: "三级 3-1-2",
                  disabled: true,
                },
              ],
            },
            {
              id: 2,
              label: "二级 2-2",
              disabled: true,
              children: [
                {
                  id: 6,
                  label: "三级 3-2-1",
                },
                {
                  id: 7,
                  label: "三级 3-2-2",
                  disabled: true,
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetEquipmentTree();
    this.searchRoomStatistics();
  },
  methods: {
    getImgSrc(i) {
      return require("../../assets/images/icon/jiegou" + i + ".png");
    },
    searchRoomStatistics() {
      this.$http
        .post("bma-distribution-service/equipment/searchRoomStatistics", {
          projectId: this.id,
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.leftList = res.data;
          }
        });
    },
    searchRoomCabinetEquipmentTree(id) {
      this.$http
        .post(
          "bma-distribution-service/equipment/searchRoomCabinetEquipmentTree",
          {
            projectId: this.id,
            roomId: id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            let arr = [];
            res.data.forEach((item) => {
              let arr2 = [];
              item.equipmentTypeTreeList.forEach((item2) => {
                let arr3 = [];
                if (item2.cabinetTreeList) {
                  item2.cabinetTreeList.forEach((item3) => {
                    let arr4 = [];
                    if (item3.equipmentTreeList) {
                      item3.equipmentTreeList.forEach((item4) => {
                        let obj4 = {
                          id: item4.id,
                          label: item4.localeNumber,
                        };
                        arr4.push(obj4);
                      });
                    }
                    let count2 = item3.sonCount || 0;
                    let obj3 = {
                      id: item3.id,
                      label: item3.cabinetNum + "（" + count2 + "）",
                      children: arr4,
                    };
                    arr3.push(obj3);
                  });
                }
                if (item2.equipmentTreeList) {
                  item2.equipmentTreeList.forEach((item3) => {
                    let obj3 = {
                      id: item3.id,
                      label: item3.localeNumber,
                    };
                    arr3.push(obj3);
                  });
                }

                let count = item2.sonCount || 0;
                let obj2 = {
                  id: item2.id,
                  label: item2.typeName + "（" + count + "）",
                  children: arr3,
                };
                arr2.push(obj2);
              });

              let obj = {
                id: item.id,
                label: item.roomName,
                children: arr2,
              };
              arr.push(obj);
            });
            this.data = arr;
            console.log(this.data);
          }
        });
    },
    roomClickHandle(index, id) {
      this.leftIndex = index;
      this.leftId = id;
    },
  },
};
</script>

<style lang="less" scoped>
.zongbao {
  display: flex;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #152139;
    letter-spacing: 3px;
    margin-bottom: 20px;
    text-align: left;
    padding: 0 20px;
    margin-top: 20px;
  }
  .left {
    width: 337px;
    height: 837px;
    background: #f8f8f9;
    box-sizing: border-box;
    ul {
      padding-left: 12px;
      li {
        width: 270px;
        height: 40px;
        border: 1px solid rgba(112, 112, 112, 0.1);
        line-height: 40px;
        font-size: 16px;
        color: #152139;
        background: rgba(163, 163, 163, 0.1);
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        padding: 0 20px;
        span {
          font-weight: 600;
        }
      }
      li {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 8px;
        }
        .sspan {
          width: 220px;
          font-size: 16px;
          text-indent: 0px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right {
    width: 1278px;
    height: 836px;
    background: #fff;
    margin-left: 15px;
    padding: 20px;
    box-sizing: border-box;
    .box {
      height: 760px;
      overflow-y: scroll;
      /deep/.el-tree {
        .el-tree-node:before {
          content: "";
          left: -4px;
          position: absolute;
          right: auto;
          border-width: 1px;
        }

        .el-tree-node:after {
          content: "";
          left: -4px;
          position: absolute;
          right: auto;
          border-width: 1px;
        }

        .el-tree-node:before {
          border-left: 1px dashed rgba(195, 195, 195, 1);
          bottom: 0px;
          height: 100%;
          top: -26px;
          width: 1px;
        }

        .el-tree-node:after {
          border-top: 1px dashed rgba(195, 195, 195, 1);
          height: 20px;
          top: 12px;
          width: 24px;
        }
        > .el-tree-node:after {
          border-top: none;
        }
        .el-tree-node {
          position: relative;
          padding-left: 16px;
        }
        //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
        .el-tree-node__expand-icon.is-leaf {
          display: none;
        }
        .el-tree-node__children {
          padding-left: 16px;
        }

        .el-tree-node :last-child:before {
          height: 38px;
        }

        > .el-tree-node:before {
          border-left: none;
        }

        > .el-tree-node:after {
          border-top: none;
        }
      }
    }
  }
}
</style>